import React from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-1 pt-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl font-bold text-foreground mb-8">Privacy Policy</h1>

          <div className="prose prose-sm max-w-none text-foreground space-y-6">
            <p className="text-muted-foreground">
              <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">1. Introduction</h2>
              <p className="text-muted-foreground">
                JobAspirant ("we," "our," or "us") is a product of Qubitly Ventures LLP. This Privacy Policy explains how we collect, use, and protect your information when you use our AI-powered resume analysis service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">2. Information We Collect</h2>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li><strong>Resume Content:</strong> Text extracted from your uploaded resume (PDF/DOCX). We do not store the original file.</li>
                <li><strong>Analysis Results:</strong> Job match scores, skills identified, skill gaps, learning roadmaps, and resume improvement suggestions.</li>
                <li><strong>Account Information:</strong> Email address, name (if provided), user tier, and credit usage.</li>
                <li><strong>Usage Data:</strong> Analysis history, learning progress tracking, and feature interactions.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">3. How We Use Your Information</h2>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>To provide AI-powered resume analysis and job matching services</li>
                <li>To generate personalized learning roadmaps and skill gap analysis</li>
                <li>To track your progress and show historical analysis results</li>
                <li>To process payments and manage your subscription</li>
                <li>To improve our services and develop new features</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">4. Data Storage & Retention</h2>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li><strong>Resume Files:</strong> We do not store your original resume file. Only extracted text is processed.</li>
                <li><strong>Analysis Data:</strong> Stored securely in cloud infrastructure to enable progress tracking and historical access.</li>
                <li><strong>Free Tier:</strong> Analysis data is automatically deleted after 30 days.</li>
                <li><strong>Paid Tier:</strong> Analysis data is retained until you request deletion or close your account.</li>
                <li>You can delete your account and all associated data at any time from Account Settings.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">5. Third-Party Services</h2>
              <p className="text-muted-foreground mb-2">We use third-party services for:</p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>Database and authentication services (hosted on secure cloud infrastructure)</li>
                <li>AI model providers for resume analysis (processes resume text only, no file storage)</li>
                <li>Payment processing (for secure transaction handling)</li>
              </ul>
            </section>


            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">6. Security</h2>
              <p className="text-muted-foreground">
                We implement industry-standard security measures including encryption, secure authentication, and access control policies to protect your data.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">7. Contact Us</h2>
              <p className="text-muted-foreground">
                For privacy-related questions, contact us at: <a href="mailto:contact@qubitlyventures.com" className="text-primary hover:underline">contact@qubitlyventures.com</a>
              </p>
              <p className="text-muted-foreground mt-2">
                <strong>Parent Company:</strong> Qubitly Ventures LLP, Delhi NCR, India
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;